<div class="container alice-model-inventory">
  <mmp5-breadcrumb></mmp5-breadcrumb>

  <section class="mm-box-container">
    <div class="mm-box-content">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h2 class="h4 mb-1">Alice — Modelos Gemini</h2>
          <p class="text-muted mb-0" *ngIf="environment || aliceGcpProjectId">
            Ambiente: <strong>{{ environment || '—' }}</strong>
            · GCP Alice: <strong>{{ aliceGcpProjectId || '—' }}</strong>
            <span *ngIf="aliceGcpLocation"> ({{ aliceGcpLocation }})</span>
          </p>
        </div>
        <div class="btn-row">
          <a routerLink="/clients/list" class="btn btn-secondary">Voltar</a>
          <button type="button" class="btn btn-primary" (click)="load()" [disabled]="loading">Atualizar</button>
        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorText">{{ errorText }}</div>
      <div class="alert alert-info" *ngIf="loading">Carregando inventário…</div>

      <form [formGroup]="filterForm" class="fields-grid filters mb-3" *ngIf="!loading">
        <div class="field">
          <label>Cliente</label>
          <input class="form-control" formControlName="companyName" placeholder="Nome" />
        </div>
        <div class="field">
          <label>Modelo</label>
          <input class="form-control" formControlName="model" placeholder="ex. gemini-2.0" />
        </div>
        <div class="field field-slot">
          <label>Slot do filtro</label>
          <select class="form-select form-control" formControlName="modelSlot">
            <option value="ANY">Qualquer slot</option>
            <option *ngFor="let s of slots" [value]="s.value">{{ s.label }}</option>
          </select>
        </div>
        <div class="field">
          <label>Projeto GCP</label>
          <input class="form-control" formControlName="clientGcp" placeholder="Alice ou cliente" />
        </div>
      </form>

      <div class="bulk-panel mb-3 p-3 border rounded" *ngIf="!loading">
        <h3 class="h6">Atualização em volume</h3>
        <form [formGroup]="bulkForm" class="bulk-form">
          <div class="fields-grid fields-grid-end">
            <div class="field field-slot">
              <label>Slot</label>
              <select class="form-select form-control" formControlName="slot">
                <option *ngFor="let s of slots" [value]="s.value">{{ s.label }}</option>
              </select>
            </div>
            <div class="field">
              <label>Só se valor atual =</label>
              <input class="form-control" formControlName="matchValue" placeholder="opcional" />
            </div>
            <div class="field field-provider">
              <label>Provider</label>
              <input class="form-control" formControlName="newProvider" />
            </div>
            <div class="field">
              <label>Novo modelo</label>
              <input class="form-control" formControlName="newValue" placeholder="gemini-2.5-flash" />
            </div>
          </div>
          <div class="bulk-actions">
            <div class="btn-row">
              <button type="button" class="btn btn-secondary" (click)="runBulk(true)" [disabled]="bulkBusy">
                Simular
              </button>
              <button type="button" class="btn btn-primary" (click)="runBulk(false)" [disabled]="bulkBusy || !lastDryRun">
                Aplicar
              </button>
            </div>
          </div>
        </form>
        <small class="text-muted">Selecionados: {{ selectedIds.length }} · Aplicar exige simulação prévia nesta sessão.</small>

        <div class="alert bulk-result bulk-result-sim mt-3 mb-0" *ngIf="lastDryRun as sim">
          <strong>Simulação — nada foi alterado ainda</strong>
          <p class="mb-2 mt-2">
            No slot <strong>{{ slotLabel(bulkForm.value.slot) }}</strong>, a troca prevista é:
          </p>
          <p class="mb-2 de-para" *ngIf="simulationSummary(sim) as s">
            <span class="de-para-line">
              <span class="label">De</span>
              <code>{{ s.fromText }}</code>
            </span>
            <span class="arrow">→</span>
            <span class="de-para-line">
              <span class="label">Para</span>
              <code>{{ s.toText }}</code>
            </span>
          </p>
          <p class="mb-2" *ngIf="bulkForm.value.matchValue">
            Só entram clientes cujo valor atual do slot é exatamente
            <code>{{ bulkForm.value.matchValue }}</code>.
          </p>
          <p class="mb-2">
            Resumo:
            <strong>{{ sim.planned || 0 }}</strong> serão alterados ·
            <strong>{{ sim.skipped || 0 }}</strong> ignorados ·
            <strong>{{ sim.failed || 0 }}</strong> com erro.
          </p>

          <div *ngIf="plannedResults(sim).length">
            <div class="fw-semibold mb-1">Clientes que serão alterados</div>
            <ul class="mb-2 result-list">
              <li *ngFor="let item of plannedResults(sim)">
                <strong>{{ clientName(item.clientId) }}</strong>:
                <code>{{ formatModel(item.oldProvider, item.oldValue) }}</code>
                →
                <code>{{ formatModel(item.newProvider, item.newValue) }}</code>
              </li>
            </ul>
          </div>

          <div *ngIf="skippedResults(sim).length">
            <div class="fw-semibold mb-1">Ignorados</div>
            <ul class="mb-0 result-list">
              <li *ngFor="let item of skippedResults(sim)">
                <strong>{{ clientName(item.clientId) }}</strong>:
                {{ skipReasonPt(item.skipReason) }}
              </li>
            </ul>
          </div>

          <div *ngIf="failedResults(sim).length" class="mt-2">
            <div class="fw-semibold mb-1">Com erro</div>
            <ul class="mb-0 result-list">
              <li *ngFor="let item of failedResults(sim)">
                <strong>{{ clientName(item.clientId) }}</strong>:
                {{ item.errorMessage || 'erro desconhecido' }}
              </li>
            </ul>
          </div>
        </div>

        <div class="alert bulk-result bulk-result-apply mt-3 mb-0" *ngIf="lastApply as apply">
          <strong>Alterações aplicadas</strong>
          <p class="mb-2 mt-2">
            Resumo:
            <strong>{{ apply.applied || 0 }}</strong> alterados ·
            <strong>{{ apply.skipped || 0 }}</strong> ignorados ·
            <strong>{{ apply.failed || 0 }}</strong> com erro.
          </p>
          <ul class="mb-0 result-list" *ngIf="plannedResults(apply).length">
            <li *ngFor="let item of plannedResults(apply)">
              <strong>{{ clientName(item.clientId) }}</strong>:
              <code>{{ formatModel(item.oldProvider, item.oldValue) }}</code>
              →
              <code>{{ formatModel(item.newProvider, item.newValue) }}</code>
            </li>
          </ul>
        </div>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>
                <input type="checkbox" (change)="toggleSelectFiltered($any($event.target).checked)" />
              </th>
              <th>Cliente</th>
              <th>Modelo LLM</th>
              <th>Modelo de Embedding</th>
              <th>Modelo de LLM mais barato</th>
              <th>Modelo de Ferramentas</th>
              <th>Modelo de Geração de Imagens</th>
              <th>GCP cliente</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of filteredRows">
              <td><input type="checkbox" [(ngModel)]="row.selected" [ngModelOptions]="{standalone: true}" /></td>
              <td>{{ row.companyName }}</td>
              <td><code>{{ row.chatModel || '—' }}</code></td>
              <td><code>{{ row.embeddingModel || '—' }}</code></td>
              <td><code>{{ row.cheaperModel || '—' }}</code></td>
              <td><code>{{ row.toolsModel || '—' }}</code></td>
              <td><code>{{ row.imageModel || '—' }}</code></td>
              <td>{{ row.clientGcpProjectId || '—' }}</td>
              <td><a [routerLink]="['/clients/view', row.clientId]">Abrir</a></td>
            </tr>
            <tr *ngIf="!filteredRows.length">
              <td colspan="9" class="text-center text-muted">Nenhum cliente Alice encontrado com os filtros atuais.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</div>
